import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import PaginationSkeleton from 'Component/skeleton/pagination';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const UserSkeleton = () => {
  return (
    <Box padding="32px 24px">
      <Flex mb="12px" className={styles['section__head']}>
        <SkeletonComponent height="30px" width="214px" mb="4px" />
      </Flex>

      <Flex className={styles['section__filter']}>
        <Flex gap="12px">
          <SkeletonComponent height="34px" width="337px" />
          <SkeletonComponent height="34px" width="168px" />
          <SkeletonComponent height="34px" width="168px" />
          <SkeletonComponent height="34px" width="168px" />
        </Flex>

        <SkeletonComponent height="34px" width="151px" />
      </Flex>

      <Box className={styles['section__table']}>
        <Table className={styles['table__skeleton']}>
          <Thead>
            <Tr>
              <Th className={styles['skeleton__head']} width="230px">
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="60%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th width="200px" className={styles['skeleton__head']}>
                <Flex>
                  <SkeletonComponent height="21px" width="50%" mb="2px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="60%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="70%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="70%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="70%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']}>
                <Flex>
                  <SkeletonComponent height="21px" width="70%" />
                </Flex>
              </Th>
              <Th width="194px" className={styles['skeleton__head']}>
                <Flex justifyContent="center">
                  <SkeletonComponent height="21px" width="50%" />
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Iteration
              items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
              render={(num) => {
                return (
                  <Tr key={num}>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <Flex gap="10px" justifyContent="center">
                        <SkeletonComponent height="42px" width="42px" borderRadius="16px" />
                        <SkeletonComponent height="42px" width="42px" borderRadius="8px" />
                      </Flex>
                    </Td>
                  </Tr>
                );
              }}
            />
          </Tbody>
        </Table>
      </Box>

      <Box className={styles['section__pagination--wrapper']}>
        <Box className={styles['section__pagination']}>
          <PaginationSkeleton />
        </Box>
      </Box>
    </Box>
  );
};

export default UserSkeleton;
